export default "__VITE_ASSET__DVRo8ACR__"